import { genericCRUDService } from '../../helpers/api';

export const SERVICE_URI = '/stocks';
export const BASE_URI = '/api/v1/article-types';

export const { findAll, findOne, create, update, remove } = genericCRUDService(
  SERVICE_URI,
  BASE_URI,
);
